function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.0275 54.2256C35.5235 52.5035 35.2794 49.7188 33.5573 48.2227L15.5464 32.4416L87.1384 32.0028C89.491 31.9884 91.4191 30.0366 91.4047 27.6839C91.3902 25.3312 89.4384 23.4031 87.0857 23.4176L15.4938 23.8563L33.3099 7.85561C35.0123 6.13219 35.2235 3.5511 33.7065 1.84741C31.983 0.14499 29.4019 -0.0662125 27.6982 1.45083L1.65253 25.0144C-0.503669 26.7819 -0.154493 29.8755 1.69073 31.2469L28.0246 54.6958C29.7261 56.192 32.5316 55.9684 34.0275 54.2256Z",
  fill: "#3A3A4B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.8067 99.9465L99.8537 76.5893C101.925 74.5128 102.033 71.9323 99.8142 70.1504L73.4804 46.7015C71.7583 45.2054 68.9736 45.4495 67.4775 47.1717C65.3887 49.8262 66.8496 52.4796 67.9477 53.1746L85.9586 68.9557L14.5731 69.3932C12.2204 69.4077 10.2924 71.3595 10.3068 73.7122C10.3212 76.0648 12.046 77.9943 14.4194 77.9797L85.9905 77.5411L68.1745 93.5418C66.4721 95.2652 66.2609 97.8463 67.7779 99.55C69.522 101.252 72.1031 101.464 73.8067 99.9465Z",
  fill: "#3A3A4B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 101,
  height: 101,
  fill: "white"
})));

var SvgSwitch = function SvgSwitch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSwitch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/switch.0995ac70.svg";
export { ForwardRef as ReactComponent };